import { gql } from '@apollo/client'

export const CREATE_USER = gql`
    mutation booking_create_user($request: CreateBookingUserRequest!) {
        booking_create_user(request: $request) {
            success
        }
    }
`
